import { render, staticRenderFns } from "./addScenery.vue?vue&type=template&id=521784f2&scoped=true&"
import script from "./addScenery.vue?vue&type=script&lang=js&"
export * from "./addScenery.vue?vue&type=script&lang=js&"
import style0 from "./addScenery.vue?vue&type=style&index=0&id=521784f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521784f2",
  null
  
)

export default component.exports